import { SaveButton } from '../../../../../common/button/save-button/SaveButton';
import Modal from '../../../../../common/modal/Modal';

import './MissedVisitWarning.css';

const MissedVisitWarning = ({ participant, show, onLogMissedVisitClick, onLogVisitLaterClick, onLogVisitNowClick }) => {
  if (!show) return null;

  return (
    <Modal headerTitle="Uncaptured Visit Alert" justifyContent="center" contentPadding="5px 15px" hideButton>
      <p className="missed-visit-warning-message">
        Attention: Visit <span>{participant.captureVisit.visitCode}</span> has not been logged, and the window period
        for this visit has now passed.
      </p>
      <p className="missed-visit-warning-message">
        Please confirm whether the visit was missed or if it still needs to be logged:
      </p>

      <div className="missed-visit-warning-buttons">
        <SaveButton
          textColor="#ffffff"
          border="1px solid #077187"
          title="Log as Missed Visit"
          onClick={onLogMissedVisitClick}
          color="#077187"
        />
        <SaveButton
          textColor="#077187"
          border="1px solid #077187"
          title="Log Visit Later"
          onClick={onLogVisitLaterClick}
          color="#ffffff"
        />
        <SaveButton
          textColor="#ffffff"
          border="1px solid #077187"
          title="Log Visit Now"
          onClick={onLogVisitNowClick}
          color="#077187"
        />
      </div>
    </Modal>
  );
};

export default MissedVisitWarning;
